<!-- Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved. -->

<div class="wrapper">
    <app-subscription-heading [subscription]="subscription" [licensesUsed]="subscription.used" [title]="title"></app-subscription-heading>
    <mat-card appearance="raised" class="card-wrapper">
        <mat-card-header>
            <mat-card-title>
                {{ 'products.included-software-title' | translate }}
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <table mat-table [dataSource]="data" aria-label="Information about included BitLocker software products">
                <ng-container matColumnDef="productName">
                    <th mat-header-cell *matHeaderCellDef>{{'products.product-name' | translate}}</th>
                    <td mat-cell *matCellDef="let software">
                        <span *ngIf="software.hasEndpoints; else justTheName">
                            <a [routerLink]="['/endpoints']" [queryParams]="{endpoints_target:'inventory'}">{{software.productName}}</a>
                        </span>
                        <ng-template #justTheName>
                            <span>{{software.productName}}</span>
                        </ng-template>
                    </td>

                </ng-container>

                <ng-container matColumnDef="assignedLicenses">
                    <th mat-header-cell *matHeaderCellDef>{{'products.assigned-licenses' | translate}}</th>
                    <td mat-cell *matCellDef="let software">
                        <span *ngIf="software.licensesApply; else doesNotApply">
                            {{software.assignedLicenses | number}}
                        </span>
                        <ng-template #doesNotApply>
                            <span>{{'N_A' | translate}}</span>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="purchasedQuantity">
                    <th mat-header-cell *matHeaderCellDef>{{'products.purchased-quantity' | translate}}</th>
                    <td mat-cell *matCellDef="let software">{{software.purchasedQuantity | number}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
            </table>
        </mat-card-content>
    </mat-card>

    <mat-card *ngIf="subscription.used > 0" appearance="raised" class="card-wrapper">
        <app-sub-endpoint-list [subscriptionId]="subscription.id"></app-sub-endpoint-list>
    </mat-card>
</div>
